import React, { memo } from 'react';
import { Loader } from "../Loader";
import { Error } from "../Error";
export var Wait = /*#__PURE__*/memo(function (_ref) {
  var isLoading = _ref.isLoading,
    isError = _ref.isError,
    onError = _ref.onError;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isLoading && /*#__PURE__*/React.createElement(Loader, {
    "data-t-id": "components-Wait"
  }), isError && /*#__PURE__*/React.createElement(Error, {
    onError: onError
  }));
});